const preloader = document.getElementById('preloader');
const site = document.getElementById('site-content');
const brand = document.getElementById('brand');

setTimeout(() => {
  if (brand) brand.classList.add('show');
}, 400);

setTimeout(() => {
  if (brand) brand.classList.add('hold');
}, 1200);

setTimeout(() => {
  if (brand) brand.classList.add('hide');
  if (preloader) preloader.classList.add('open');
  if (site) site.classList.add('show');
}, 1800);

setTimeout(() => {
  if (preloader) preloader.remove();
  document.body.style.overflow = 'auto';
}, 3200);